import Link from "next/link";
import {
  FC,
  useEffect,
  useRef,
  useState,
} from "react";
import { Accordion, Navbar } from "react-bootstrap";

import MenuItem from "../../dtos/MenuItem.dto";
import Text from "../../styled/Text";
import SlideDrawer from "../SlideDrawer";
import CorneredBox from "../CorneredBox";
import {
  CardBox,
  CardHeader,
  CardBody,
  LinkText,
  MenuButton,
  HeaderDiv,
} from "./Header.styled";
import LoginPopup from "../LoginPopup";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { setLoggedInUser } from "../../redux/loggedInUser/loggedInUser.actions";
import { updateNewCheckoutState } from "../../redux/newCheckout/newCheckout.actions";
import { useRouter } from "next/router";
import shouldRedirectOnLogout from "../../utils/shouldRedirectOnLogout";
import { Site_url } from "../../api/config";

interface AccordionItemProps {
  menu?: MenuItem[];
  depth: number;
  isOpen: any;
}

const AccordionMenu: FC<AccordionItemProps> = ({ menu, depth, isOpen }) => {
  const [activeKey, setActiveKey] = useState<string>("");
  depth++;

  if (!menu) return null;

  const clickHandler = (i: any, e: any) => {
    e.preventDefault();
    window.location.href = `https://www.ezylegal.in${i}`;
    document.body.removeAttribute("style");
    document.getElementById("cornered_box")?.removeAttribute("style");
    isOpen();
  };

  return (
    <Accordion activeKey={activeKey} onSelect={(i: any) => setActiveKey(i)}>
      {menu?.map((menu: MenuItem, i: number) =>
        menu.children.length ? (
          <CardBox key={i}>
            <CardHeader border={depth === 1 ? 1 : 0}>
              <Accordion.Toggle as="span" eventKey={String(i)}>
                <div className="row">
                  <div className="col">
                    <Text as="a" fontSize={depth === 1 ? "lg" : "md"} block>
                      {menu.label}
                    </Text>
                  </div>
                  <div className="col-auto">
                    {activeKey === String(i) ? (
                      <img
                        src="/city-lawyers/icons/keyboard_arrow_up.svg"
                        alt="Up"
                        width="12"
                      />
                    ) : (
                      <img
                        src="/city-lawyers/icons/keyboard_arrow_down.svg"
                        alt="Down"
                        width="12"
                      />
                    )}
                  </div>
                </div>
              </Accordion.Toggle>
            </CardHeader>
            <Accordion.Collapse eventKey={String(i)}>
              <CardBody>
                <AccordionMenu
                  menu={menu.children}
                  depth={depth}
                  isOpen={isOpen}
                />
              </CardBody>
            </Accordion.Collapse>
          </CardBox>
        ) : (
          <Link key={i} href={menu.url}>
            <LinkText
              onClick={(e: any) => clickHandler(menu.url, e)}
              fontSize={depth === 1 ? "lg" : "md"}
              as="a"
              block
            >
              {menu.label}
            </LinkText>
          </Link>
        )
      )}
    </Accordion>
  );
};

interface MobileHeaderProps {
  headerMenu?: MenuItem[];
  widthSize?: number | null;
  bgColorBack?:
    | "primary"
    | "secondary"
    | "darkBlue"
    | "skyBlue"
    | "white"
    | "lightSkyBlue";
}

const MobileLogin = () => {
  const [showModal, setShowModal] = useState({
    show: false,
    tabValue: "LOGIN",
  });
  const router = useRouter();

  const setTab = (tabValue: string) => {
    setShowModal({
      ...showModal,
      tabValue: tabValue,
    });
  };

  return (
    <>
      <a>
        <LinkText color={"gray-500"}>For Customers</LinkText>
      </a>

      <a
        onClick={() => {
          const elem = document.querySelector("body");
          if (elem) {
            elem.style.overflow = "unset";
            setShowModal({
              show: true,
              tabValue: "REGISTER",
            });
          }
        }}
      >
        <LinkText>Register Now</LinkText>
      </a>
      <a
        onClick={() => {
          const elem = document.querySelector("body");
          if (elem) {
            elem.style.overflow = "unset";
            setShowModal({
              show: true,
              tabValue: "Login",
            });
          }
        }}
      >
        <LinkText>Login</LinkText>
      </a>

      <br />

      <a>
        <LinkText color={"gray-500"}>For Lawyers & CA</LinkText>
      </a>

      <a
        onClick={() => {
          const elem = document.querySelector("body");
          if (elem) {
            elem.style.overflow = "unset";
            const newPath = `${Site_url}join-our-network?register=true`;
            window.location.href = newPath;
            // router.push({
            //   pathname: "/join-our-network",
            //   query: { register: true },
            // });
          }
        }}
      >
        <LinkText>Register</LinkText>
      </a>

      <a
        onClick={() => {
          const elem = document.querySelector("body");
          if (elem) {
            elem.style.overflow = "unset";
            const newPath = `${Site_url}join-our-network`;
            window.location.href = newPath;
            // router.push({
            //   pathname: "/join-our-network",
            // });
          }
        }}
      >
        <LinkText>Login</LinkText>
      </a>

      {showModal.show && (
        <LoginPopup
          tabValue={showModal.tabValue}
          show={showModal.show}
          handleClose={() => {
            setShowModal({
              show: false,
              tabValue: "LOGIN",
            });
          }}
          setTab={setTab}
          mobileView={true}
        />
      )}
    </>
  );
};

const UserInfo = ({ name, type }: { name: string; type: string }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const loggedInUserData = useSelector(
    (store: RootState) => store.loggedInUser
  );
  const { asPath } = router;
  return (
    <>
      <a>
        <LinkText>
          <Text color={"gray-500"}> Hi, {name} </Text>
        </LinkText>
      </a>

      <a
        onClick={() => {
          if (type === "AGENT") {
            const newPath = window.location.origin + "/expert/profile";
            window.location.replace(newPath);
          } else {
            const newPath = `${Site_url}profile`;
            window.location.href = newPath;
            // router.push("/profile");
          }
        }}
      >
        <LinkText>My Profile</LinkText>
      </a>

      <a
        onClick={() => {
          const newPath = `${Site_url}dashboard`;
          window.location.href = newPath;
          // router.push("/dashboard");
        }}
      >
        <LinkText> My Orders </LinkText>
      </a>

      {type === "AGENT" ? (
        <a
          onClick={() => {
            const newPath = window.location.origin + "/expert/";
            window.location.replace(newPath);
          }}
        >
          <LinkText> My Dashboard </LinkText>
        </a>
      ) : null}

      {loggedInUserData?.user_type !== "AGENT" &&
      loggedInUserData?.organization &&
      loggedInUserData?.organization !== "" ? (
        <a
          onClick={() => {
            const newPath = `${Site_url}business/?_id=${loggedInUserData._id}&token=${loggedInUserData.jwt_token}`;
            window.location.href = newPath;
            localStorage.setItem("business_checkout", "1");
          }}
        >
          <LinkText> My Business </LinkText>
        </a>
      ) : null}

      <a
        onClick={() => {
          localStorage.removeItem("ezyLegalUserData");
          localStorage.removeItem("persist:root");
          localStorage.removeItem("persist:lawyerRoot");
          dispatch(setLoggedInUser(null));
          dispatch(updateNewCheckoutState({ newUserData: null }));
          if (shouldRedirectOnLogout(asPath)) {
            router.push("/");
          }
        }}
      >
        <LinkText> Logout </LinkText>
      </a>
    </>
  );
};

const MobileHeader: FC<MobileHeaderProps> = ({
  headerMenu,
  bgColorBack,
  widthSize,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const nodeRef = useRef<any>();

  // const { ref } = useSwipeable({
  //   trackTouch: true,
  //   onSwipedRight: () => setIsOpen(true),
  //   onSwipedLeft: () => setIsOpen(false),
  // }) as { ref: RefCallback<Document> };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (nodeRef.current && nodeRef.current.contains(e.target)) {
        // inside click
        return;
      }

      // outside click
      setIsOpen(false);
      document.body.removeAttribute("style");
      document.getElementById("cornered_box")?.removeAttribute("style");
    };

    document.addEventListener("mousedown", handleClickOutside);

    // ref(document);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (!isOpen) {
      document.body.removeAttribute("style");
    }
  }, [isOpen]);

  const loggedInUserData = useSelector(
    (store: RootState) => store.loggedInUser
  );
  const MenuBackDrop = () => {
    document.body.style.overflow = "hidden";
    document
      .getElementById("cornered_box")
      ?.setAttribute(
        "style",
        "position: fixed;;width: 100%;height: 100%;top: 0;left: 0;right: 0;bottom: 0;background-color: rgba(0,0,0,0.5);z-index: 201;cursor: pointer;"
      );
  };
  const close = () => {
    setIsOpen(false);
  };
  return (
    <>
      <HeaderDiv
        className="container py-2 position-relative"
        style={{ zIndex: 999 }}
      >
        <div className="row align-items-center">
          <div className="col">
            <div className="d-flex align-items-center">
              <MenuButton
                onClick={() => {
                  setIsOpen(!isOpen);
                  MenuBackDrop();
                }}
              >
                <img
                  src="/city-lawyers/icons/menu_24px.svg"
                  alt="Menu"
                  width="35"
                />
              </MenuButton>
              <Link href="https://www.ezylegal.in">
                <Navbar.Brand>
                  <img
                    src="/city-lawyers/images/logo.svg"
                    alt="Logo"
                    height="50"
                    className="d-inline-block align-text-top"
                  />
                </Navbar.Brand>
              </Link>
            </div>
          </div>

          {isOpen ? (
            <a
              id="close"
              style={{
                zIndex: 200,
                fontSize: 25,
                fontWeight: 400,
                color: "white",
              }}
              className={widthSize ? (widthSize > 910 ? "" : "col-2") : "col-2"}
              onClick={(e) => {
                e.preventDefault();
                setIsOpen(false);
              }}
            >
              X
            </a>
          ) : (
            ""
          )}
        </div>
      </HeaderDiv>
      <CorneredBox zIndex={1} bgColor="white" bgColorBack={bgColorBack}>
        <SlideDrawer nodeRef={nodeRef} isOpen={isOpen}>
          <div className="logo p-4">
            <img
              src="/city-lawyers/images/logo.svg"
              alt="Logo"
              height="40"
              className="d-inline-block align-text-top"
            />
          </div>
          <AccordionMenu menu={headerMenu} depth={1} isOpen={close} />
          <hr />
          {loggedInUserData?.name ? (
            <UserInfo
              name={loggedInUserData?.name}
              type={loggedInUserData.user_type}
            />
          ) : (
            <MobileLogin />
          )}
        </SlideDrawer>
      </CorneredBox>
    </>
  );
};

export default MobileHeader;
